// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
	Array.from = (function() {
		var toStr = Object.prototype.toString;
		var isCallable = function(fn) {
			return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
		};
		var toInteger = function(value) {
			var number = Number(value);
			if (isNaN(number)) {
				return 0;
			}
			if (number === 0 || !isFinite(number)) {
				return number;
			}
			return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
		};
		var maxSafeInteger = Math.pow(2, 53) - 1;
		var toLength = function(value) {
			var len = toInteger(value);
			return Math.min(Math.max(len, 0), maxSafeInteger);
		};

		// The length property of the from method is 1.
		return function from(arrayLike /*, mapFn, thisArg */) {
			// 1. Let C be the this value.
			var C = this;

			// 2. Let items be ToObject(arrayLike).
			var items = Object(arrayLike);

			// 3. ReturnIfAbrupt(items).
			if (arrayLike == null) {
				throw new TypeError('Array.from requires an array-like object - not null or undefined');
			}

			// 4. If mapfn is undefined, then let mapping be false.
			var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
			var T;
			if (typeof mapFn !== 'undefined') {
				// 5. else
				// 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
				if (!isCallable(mapFn)) {
					throw new TypeError('Array.from: when provided, the second argument must be a function');
				}

				// 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
				if (arguments.length > 2) {
					T = arguments[2];
				}
			}

			// 10. Let lenValue be Get(items, "length").
			// 11. Let len be ToLength(lenValue).
			var len = toLength(items.length);

			// 13. If IsConstructor(C) is true, then
			// 13. a. Let A be the result of calling the [[Construct]] internal method
			// of C with an argument list containing the single item len.
			// 14. a. Else, Let A be ArrayCreate(len).
			var A = isCallable(C) ? Object(new C(len)) : new Array(len);

			// 16. Let k be 0.
			var k = 0;
			// 17. Repeat, while k < len… (also steps a - h)
			var kValue;
			while (k < len) {
				kValue = items[k];
				if (mapFn) {
					A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
				} else {
					A[k] = kValue;
				}
				k += 1;
			}
			// 18. Let putStatus be Put(A, "length", len, true).
			A.length = len;
			// 20. Return A.
			return A;
		};
	})();
}

// Promise Polyfill
!(function(e, t) {
	'object' == typeof exports && 'undefined' != typeof module ? t() : 'function' == typeof define && define.amd ? define(t) : t();
})(0, function() {
	'use strict';
	function e(e) {
		var t = this.constructor;
		return this.then(
			function(n) {
				return t.resolve(e()).then(function() {
					return n;
				});
			},
			function(n) {
				return t.resolve(e()).then(function() {
					return t.reject(n);
				});
			}
		);
	}
	function t(e) {
		return new this(function(t, n) {
			function o(e, n) {
				if (n && ('object' == typeof n || 'function' == typeof n)) {
					var f = n.then;
					if ('function' == typeof f)
						return void f.call(
							n,
							function(t) {
								o(e, t);
							},
							function(n) {
								(r[e] = { status: 'rejected', reason: n }), 0 == --i && t(r);
							}
						);
				}
				(r[e] = { status: 'fulfilled', value: n }), 0 == --i && t(r);
			}
			if (!e || 'undefined' == typeof e.length) return n(new TypeError(typeof e + ' ' + e + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
			var r = Array.prototype.slice.call(e);
			if (0 === r.length) return t([]);
			for (var i = r.length, f = 0; r.length > f; f++) o(f, r[f]);
		});
	}
	function n(e) {
		return !(!e || 'undefined' == typeof e.length);
	}
	function o() {}
	function r(e) {
		if (!(this instanceof r)) throw new TypeError('Promises must be constructed via new');
		if ('function' != typeof e) throw new TypeError('not a function');
		(this._state = 0), (this._handled = !1), (this._value = undefined), (this._deferreds = []), l(e, this);
	}
	function i(e, t) {
		for (; 3 === e._state; ) e = e._value;
		0 !== e._state
			? ((e._handled = !0),
			  r._immediateFn(function() {
					var n = 1 === e._state ? t.onFulfilled : t.onRejected;
					if (null !== n) {
						var o;
						try {
							o = n(e._value);
						} catch (r) {
							return void u(t.promise, r);
						}
						f(t.promise, o);
					} else (1 === e._state ? f : u)(t.promise, e._value);
			  }))
			: e._deferreds.push(t);
	}
	function f(e, t) {
		try {
			if (t === e) throw new TypeError('A promise cannot be resolved with itself.');
			if (t && ('object' == typeof t || 'function' == typeof t)) {
				var n = t.then;
				if (t instanceof r) return (e._state = 3), (e._value = t), void c(e);
				if ('function' == typeof n)
					return void l(
						(function(e, t) {
							return function() {
								e.apply(t, arguments);
							};
						})(n, t),
						e
					);
			}
			(e._state = 1), (e._value = t), c(e);
		} catch (o) {
			u(e, o);
		}
	}
	function u(e, t) {
		(e._state = 2), (e._value = t), c(e);
	}
	function c(e) {
		2 === e._state &&
			0 === e._deferreds.length &&
			r._immediateFn(function() {
				e._handled || r._unhandledRejectionFn(e._value);
			});
		for (var t = 0, n = e._deferreds.length; n > t; t++) i(e, e._deferreds[t]);
		e._deferreds = null;
	}
	function l(e, t) {
		var n = !1;
		try {
			e(
				function(e) {
					n || ((n = !0), f(t, e));
				},
				function(e) {
					n || ((n = !0), u(t, e));
				}
			);
		} catch (o) {
			if (n) return;
			(n = !0), u(t, o);
		}
	}
	var a = setTimeout;
	(r.prototype['catch'] = function(e) {
		return this.then(null, e);
	}),
		(r.prototype.then = function(e, t) {
			var n = new this.constructor(o);
			return (
				i(
					this,
					new (function(e, t, n) {
						(this.onFulfilled = 'function' == typeof e ? e : null), (this.onRejected = 'function' == typeof t ? t : null), (this.promise = n);
					})(e, t, n)
				),
				n
			);
		}),
		(r.prototype['finally'] = e),
		(r.all = function(e) {
			return new r(function(t, o) {
				function r(e, n) {
					try {
						if (n && ('object' == typeof n || 'function' == typeof n)) {
							var u = n.then;
							if ('function' == typeof u)
								return void u.call(
									n,
									function(t) {
										r(e, t);
									},
									o
								);
						}
						(i[e] = n), 0 == --f && t(i);
					} catch (c) {
						o(c);
					}
				}
				if (!n(e)) return o(new TypeError('Promise.all accepts an array'));
				var i = Array.prototype.slice.call(e);
				if (0 === i.length) return t([]);
				for (var f = i.length, u = 0; i.length > u; u++) r(u, i[u]);
			});
		}),
		(r.allSettled = t),
		(r.resolve = function(e) {
			return e && 'object' == typeof e && e.constructor === r
				? e
				: new r(function(t) {
						t(e);
				  });
		}),
		(r.reject = function(e) {
			return new r(function(t, n) {
				n(e);
			});
		}),
		(r.race = function(e) {
			return new r(function(t, o) {
				if (!n(e)) return o(new TypeError('Promise.race accepts an array'));
				for (var i = 0, f = e.length; f > i; i++) r.resolve(e[i]).then(t, o);
			});
		}),
		(r._immediateFn =
			('function' == typeof setImmediate &&
				function(e) {
					setImmediate(e);
				}) ||
			function(e) {
				a(e, 0);
			}),
		(r._unhandledRejectionFn = function(e) {
			void 0 !== console && console && console.warn('Possible Unhandled Promise Rejection:', e);
		});
	var s = (function() {
		if ('undefined' != typeof self) return self;
		if ('undefined' != typeof window) return window;
		if ('undefined' != typeof global) return global;
		throw Error('unable to locate global object');
	})();
	'function' != typeof s.Promise ? (s.Promise = r) : s.Promise.prototype['finally'] ? s.Promise.allSettled || (s.Promise.allSettled = t) : (s.Promise.prototype['finally'] = e);
});
